import { render, staticRenderFns } from "./CertificateExcelUploadDlg.vue?vue&type=template&id=124ffb52&"
import script from "./CertificateExcelUploadDlg.vue?vue&type=script&lang=ts&"
export * from "./CertificateExcelUploadDlg.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateExcelUploadDlg.vue?vue&type=style&index=0&id=124ffb52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports